import { createAsyncThunk } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { AXIOS, api_key } from "../config";


export const sellOrderSpot = createAsyncThunk(
  "sellOrder",
  async (orderType: string) => {
    try {
      // let userid = sessionStorage.getItem('userid')
      // console.log('userid', userid)
      // let response = await AXIOS
      //   .post(`getOrders?type=${orderType}&&method=sell`, {
      //     api_key: api_key,
      //     user_id: userid,

      //   })
      // return response.data.data
      return [
        {
          target_price: 20,
          amount: 50
        },
        {
          target_price: 30,
          amount: 50
        },
        {
          target_price: 15,
          amount: 20
        },
        {
          target_price: 23,
          amount: 15
        },
        {
          target_price: 5,
          amount: 10
        },
        {
          target_price: 9,
          amount: 11
        },
        {
          target_price: 35,
          amount: 12
        },
        {
          target_price: 9,
          amount: 19
        },
      ]
    } catch (error) {
      console.error("error while get sellorder", error);
      return []

    }
  }
)
export const buyOrderSpot = createAsyncThunk(
  "buyOrder",
  async (orderType: string) => {
    let userid = sessionStorage.getItem('userid')

    try {
      // let response = await AXIOS
      //   .post(`getOrders?type=${orderType}&&method=buy`, {
      //     api_key: api_key,
      //     user_id: userid,

      //   })
      // return response.data.data
      return [
        {
          target_price: 20,
          amount: 50
        },
        {
          target_price: 30,
          amount: 50
        },
        {
          target_price: 15,
          amount: 20
        },
        {
          target_price: 23,
          amount: 15
        },
        {
          target_price: 5,
          amount: 10
        },
        {
          target_price: 9,
          amount: 11
        },
        {
          target_price: 35,
          amount: 12
        },
        {
          target_price: 9,
          amount: 19
        },
      ]

    } catch (error) {
      console.error("error while get buyorder", error);
      return []

    }
  }
)